import RadioBase from './Radio';
export * from './Radio';
export const Radio = RadioBase;

export default RadioBase;
